/* eslint-disable */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Text from '@tds/core-text';
import { isEmpty, flattenDeep, isArray } from 'lodash';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Heading from '@tds/core-heading';
import FormSummaryRow from '../formSummaryRow';
import { GroupWrapper, GroupTitle } from '../css';
import {
  BACKEND_KEYS,
  additionalEquipment,
  easyAdditionalEquipment,
  oneTimeAdditionalEquipment,
  fieldWinbackFibre,
  valueNewTelusBusinessOrder,
  fieldWinback,
  contractTerm3Year,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  accessoryValues,
  wirelessOrderDetailsSummaryOneTimeCategories,
  wlsOneTimeCategories,
  wirelessOrderDetailsSummaryMonthlyCategories,
  wlsRecurringCategories,
  sevenX,
  deviceCareComplete,
  appleCareTier5,
  appleCareTier4A,
  appleCareTier4,
  appleCarePlus12,
  appleCarePlus9
  //  accessoryValues
} from '../../utils/constant';
import { getLocalizedStrings } from '../../misc';
import { useTranslationsContext } from '../../context/TranslationsContext';
import request from '../../utils/request';

const userDetailsKey = 'userDetails';
const formSectionKey = 'formSection';
const repeatedFormKey = 'repeatedForm';
const formFieldsGroup = 'formFieldsGroup';
const equipmentGroupSection = 'equipmentGroupSection';

const removePrice = label => {
                               // dontRemovePrice checks if label is any of device care options, if true then it doesn't remove Price from lable
                               const dontRemovePrice = [
                                 deviceCareComplete,
                                 appleCareTier5,
                                 appleCareTier4A,
                                 appleCareTier4,
                                 appleCarePlus12,
                                 appleCarePlus9
                               ].includes(label);
                               if (!dontRemovePrice) {
                                 if (
                                   !label ||
                                   (typeof label !== 'string' &&
                                     !dontRemovePrice)
                                 )
                                   return label;
                                 return label.replace(
                                   /\([\D\s]*\$[\d.\s\D]*\)/g,
                                   ''
                                 );
                               }
                               return label;
                             };

const priceClean = label => {
  if (Array.isArray(label)) {
    return label.map(filteredLabel => {
      return removePrice(filteredLabel);
    });
  }
  return label;
};

export const getFieldLabel = (options, fieldValue) => {
  if (!options || !options.length) {
    if (Array.isArray(fieldValue)) {
      return (
        fieldValue &&
        fieldValue.length > 0 &&
        fieldValue.map(field => priceClean(field))
      );
    }
    return priceClean(fieldValue);
  }
  for (let i = 0; i < options.length; i += 1) {
    const option = options[i];
    const fields = option.fields || {};
    const { label, value } = fields || {};
    if (value === fieldValue) {
      return priceClean(label);
    }
  }

  if (Array.isArray(fieldValue) && fieldValue.length === 0) {
    return null;
  }
  return priceClean(fieldValue);
};

const profile = request.getProfile();
const OrderSummary = ({ stepData, orderData }) => {
  const channelWLS = profile.channel === undefined ? '' : profile.channel;
  const isChannelSevenX = channelWLS && channelWLS.name === sevenX;
  const {
    contentfulValues: { yes, no }
  } = getLocalizedStrings();
  const summaryStepsData = useMemo(() => {
    const stepsData = (stepData && [...stepData]) || [];
    stepsData.splice(stepsData.length - 1, 1);
    return stepsData;
  }, stepData);

  const groupSummary = (
    fieldNamesArray,
    formStepFieldsArray,
    groupOrderData
  ) => {
    return formStepFieldsArray.map((formStepFields, index) => {
      if (!formStepFields) return null;
      const nonEmptyFields =
        formStepFields &&
        formStepFields.filter(currentField => {
          const {
            fields: { backendKey }
          } = currentField || {};
          const isObject = typeof groupOrderData[backendKey] === 'object';
          const isArray = Array.isArray(groupOrderData[backendKey]);
          if (isObject && !isArray) {
            return !!groupOrderData[backendKey].value;
          }
          if (isArray && groupOrderData[backendKey].length) {
            return true;
          }
          return !!groupOrderData[backendKey];
        });

      if (!nonEmptyFields || !nonEmptyFields.length) return null;
      const setTitle = label => {
        if (label === additionalEquipment) {
          return `${label} (${oneTimeAdditionalEquipment})`;
        }
        if (label === easyAdditionalEquipment) {
          return `${additionalEquipment} (${label})`;
        }
        return label;
      };
      return (
        <GroupWrapper style={{ marginBottom: '1em' }}>
          <GroupTitle style={{ marginBottom: '1em' }}>
            {setTitle(fieldNamesArray[index])}
          </GroupTitle>
          {nonEmptyFields &&
            nonEmptyFields.map(({ fields: { backendKey, label, options } }) => {
              let fieldValue = '';
              const isArray = Array.isArray(groupOrderData[backendKey]);
              const isObject = typeof groupOrderData[backendKey] === 'object';
              if (isObject && !isArray) {
                fieldValue = priceClean(groupOrderData[backendKey].value);
              } else if (isArray) {
                fieldValue = groupOrderData[backendKey]
                  .join(', ')
                  .split(',')
                  .map(item => priceClean(item))
                  .join(',');
              } else {
                fieldValue = priceClean(groupOrderData[backendKey]);
              }
              const labelLogic =
                fieldNamesArray[index] &&
                fieldNamesArray[index] === additionalEquipment
                  ? priceClean(label)
                  : priceClean(label);
              return (
                <FormSummaryRow
                  label={labelLogic}
                  value={getFieldLabel(options, fieldValue)}
                  isDollarRemove
                />
              );
            })}
        </GroupWrapper>
      );
    });
  };

  const handleFormSummaryRow = (
    {
      fieldLabel,
      fieldBackendKey,
      fieldName,
      formStepFields,
      contentfulId,
      formTitle,
      options: mainOptions,
      appearsAfterValue,
      appearsAfterField,
      easyPaymentFields,
      easyPaymentTitle
    },
    customOrderData
  ) => {
    const dataOrder = customOrderData || orderData;

    if (
      (fieldName === fieldWinbackFibre || fieldName === fieldWinback) &&
      dataOrder.orderType !== valueNewTelusBusinessOrder
    )
      return null;
    if (contentfulId === userDetailsKey) {
      if (isChannelSevenX) {
        fieldName = fieldName.replace('Service /', '');
      }
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formFieldsGroup) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === equipmentGroupSection) {
      if (dataOrder[fieldName] && Object.keys(dataOrder[fieldName]).length) {
        let conditionField = null;
        let conditionValue = null;
        if (appearsAfterField && appearsAfterField.length) {
          const [
            {
              fields: { backendKey: appearsBackendKey }
            }
          ] = appearsAfterField || [{}];
          if (appearsBackendKey) {
            conditionField = appearsBackendKey;
          }
        }
        if (appearsAfterValue && appearsAfterValue.length) {
          const [
            {
              fields: { value: appearsValue }
            }
          ] = appearsAfterValue || [{}];
          if (appearsValue) {
            conditionValue = appearsValue;
          }
        }
        if (
          conditionField &&
          conditionValue &&
          dataOrder[conditionField] !== conditionValue
        ) {
          return null;
        }
        const paymentsFields = easyPaymentFields || [];
        return groupSummary(
          [formTitle, easyPaymentTitle],
          [formStepFields, paymentsFields],
          dataOrder[fieldName]
        );
      }
      return null;
    }
    if (contentfulId === formSectionKey) {
      return (
        formStepFields &&
        formStepFields.length > 0 &&
        formStepFields.map(item => {
          const {
            fields: {
              label,
              backendKey,
              name: sectionFieldName,
              fields: groupFields,
              formFields: sectionFormFields,
              title,
              formTitle: sectionFormTitle
            },
            sys: {
              contentType: {
                sys: { id: fieldContentfulId }
              }
            }
          } = item || {};
          const rowObj = {
            fieldLabel: label,
            fieldBackendKey: backendKey,
            fieldName: sectionFieldName || title,
            formStepFields: groupFields || sectionFormFields,
            contentfulId: fieldContentfulId,
            formTitle: title || sectionFormTitle
          };
          return handleFormSummaryRow(rowObj, customOrderData);
        })
      );
    }
    if (contentfulId === repeatedFormKey) {
      return (
        dataOrder[fieldName] &&
        dataOrder[fieldName].map((row, idx) =>
          groupSummary([`${formTitle} ${idx + 1}`], [formStepFields], row)
        )
      );
    }
    const fieldKey =
      (dataOrder[fieldBackendKey] && fieldBackendKey) || fieldName;
    let fieldValue = getFieldLabel(mainOptions, dataOrder[fieldKey]);

    // Check if the type can be converted to float
    let typeCheckedFieldValue = parseFloat(fieldValue);

    // Check if the value really is in decimals and needs rounding off
    if (typeCheckedFieldValue && typeCheckedFieldValue % 1 !== 0) {
      typeCheckedFieldValue = typeCheckedFieldValue.toFixed(2);
    } else if (typeof fieldValue === 'boolean') {
      typeCheckedFieldValue = fieldValue ? yes : no;
    } else {
      typeCheckedFieldValue = fieldValue;
    }

    return (
      <FormSummaryRow
        label={fieldLabel}
        value={typeCheckedFieldValue}
        isDollarRemove
      />
    );
  };

  const rowCb = (formStepFields, customOrderData) => {
    return formStepFields.map(
      ({
        fields: {
          label: fieldLabel,
          outputLabel,
          backendKey: fieldBackendKey,
          formStepFields: subStepFields,
          easyPaymentFields,
          easyPaymentTitle,
          formFields: repeatedGroupFields,
          appearsAfterField,
          appearsAfterValue,
          fields: groupFields,
          name: fieldName,
          title: groupTitle,
          formTitle,
          options
        },
        sys: {
          contentType: {
            sys: { id: contentfulId }
          }
        }
      }) => (
        <>
          {handleFormSummaryRow(
            {
              fieldLabel: outputLabel || fieldLabel,
              fieldBackendKey,
              formStepFields:
                subStepFields || repeatedGroupFields || groupFields,
              fieldName: fieldName || groupTitle,
              contentfulId,
              formTitle: formTitle || groupTitle,
              options,
              appearsAfterField,
              appearsAfterValue,
              easyPaymentFields,
              easyPaymentTitle
            },
            customOrderData
          )}
        </>
      )
    );
  };

  const handleOfficePhone = (stepName, formStepFields) => {
    return (
      orderData &&
      orderData.officePhoneData.map((mainLine, idx) => {
        return (
          <>
            {groupSummary(
              [`${stepName} ${idx + 1}`],
              [formStepFields],
              mainLine
            )}
            {mainLine &&
              mainLine.ovLines &&
              mainLine.ovLines.map((ovLine, ovIdx) =>
                groupSummary(
                  [`${stepName} ${idx + 1}.${ovIdx + 1}`],
                  [formStepFields],
                  ovLine
                )
              )}
          </>
        );
      })
    );
  };

  const {
    WLS: {
      SUBSCRIBER_DETAILS: { Name, Price, Features, Accessories }
    }
  } = useTranslationsContext();

  // Find Features for summary page
  let summaryFeatures =
    orderData.subscriberDetails &&
    orderData.subscriberDetails.map(
      item =>
        item &&
        item.features.map(feature => {
          return {
            name: feature.name,
            price: feature.price.toFixed(2)
          };
        })
    );
  summaryFeatures = flattenDeep(summaryFeatures);

  // Find Accessories for summary page
  let summaryAccessories =
    orderData.subscriberDetails &&
    orderData.subscriberDetails.map(
      item =>
        item &&
        item.accessories.map(accessory => {
          return {
            //name: accessory.name,
            //price: accessory.price.toFixed(2)
            category: accessory.category,
            product: accessory.product,
            price: accessory.price.toFixed(2),
            sku: accessory.sku
            // tax: accessory.tax.toFixed(2)
          };
        })
    );
  summaryAccessories = flattenDeep(summaryAccessories);

  const handleWirelessSummary = (_stepName, formStepFields) => {
    const {
      WLS: {
        SUBSCRIBER_DETAILS: {
          TotalContractValue,
          HardwareSummary,
          SUBSCRIBER,
          CATEGORIES
        }
      },
      contentfulValues: {
        wirelessOrderDetails: { valueTwoYear, valueOwnersAdvantagePlan }
      }
    } = useTranslationsContext();
    const {
      contentfulValues: { HARDWARE }
    } = getLocalizedStrings();
    const subscriberDetails =
      orderData.subscriberDetails &&
      orderData.subscriberDetails.map(
        ({ subscriberDetailsDevices, ...rest }) => rest
      );
    const devices = orderData.subscriberDetails;
    /**
     * subscriberDetailsCpoCategory
     * subscriberDetailsDevicePlan
     * provinceWLS
     * subscriberDetailsTier
     * isCop ?
     */

    const getSubscriberPlanYears = subscriberDetail => {
      if (subscriberDetail.subscriberDetailsContractTerm === valueTwoYear)
        return 24;
      else if (
        subscriberDetail.subscriberDetailsContractTerm ===
        valueOwnersAdvantagePlan
      )
        return 12;
      else if (
        subscriberDetail.subscriberDetailsContractTerm ===
          contractTerm3Year[0] ||
        subscriberDetail.subscriberDetailsContractTerm === contractTerm3Year[1]
      )
        return 36;
      return 24;
    };

    const categories = {
      devicesTotal: 0,
      ratePlanTotal: 0,
      easyPaymentTotal: 0,
      deviceSalesTax: 0,
      featuresTotal: 0,
      accessoriesTotal: 0,
      additionalFeaturesTotal: 0,
      simTotal: 0,
      additionalCharges: 0,
      oneTimeTotal: 0,
      monthlyTotal: 0,
      total: 0
    };

    if (subscriberDetails) {
      subscriberDetails.forEach((sd, index) => {
        const subscriberYearPlan = getSubscriberPlanYears(
          subscriberDetails[index]
        );
        if (sd.recurringCost) {
          const categoryKeysToAutoUpdate = [
            {
              categoryKey: 'ratePlanTotal',
              sdTotalKey: 'rateplanTotal',
              recurring: true
            },
            {
              categoryKey: 'easyPaymentTotal',
              sdTotalKey: 'easyPaymentTotal',
              recurring: true
            },
            {
              categoryKey: 'devicesTotal',
              sdTotalKey: 'deviceUpfrontCost',
              recurring: false
            },
            {
              categoryKey: 'deviceSalesTax',
              sdTotalKey: 'taxes',
              recurring: false
            },
            {
              categoryKey: 'additionalCharges',
              sdTotalKey: 'deviceEnrolmentProgram',
              recurring: false
            },
            {
              categoryKey: 'simTotal',
              sdTotalKey: 'simPrice',
              recurring: false
            }
          ];
          categoryKeysToAutoUpdate.forEach(category => {
            if (category.recurring) {
              // For categories that have monthly charges
              categories[category.categoryKey] +=
                sd.recurringCost[category.sdTotalKey] * subscriberYearPlan;
            } else {
              // For categories that have one time charges
              categories[category.categoryKey] +=
                sd.oneTimeCost[category.sdTotalKey];
            }
          });
        }
        sd.accessories.forEach(
          accessory => (categories.accessoriesTotal += accessory.price)
        );
        sd.features.forEach(feature => {
          if (feature.isCustom) {
            categories.additionalFeaturesTotal +=
              feature.price * subscriberYearPlan;
          } else {
            categories.featuresTotal += feature.price * subscriberYearPlan;
          }
        });
      });
    }

    // Quick fixes
    categories.ratePlanTotal =
      categories.ratePlanTotal -
      (categories.featuresTotal + categories.additionalFeaturesTotal);

    // Total calculations
    let oneTimeTotal = 0;
    let monthlyTotal = 0;
    wlsOneTimeCategories.forEach(category => {
      oneTimeTotal = oneTimeTotal + categories[category];
    });

    wlsRecurringCategories.forEach(category => {
      monthlyTotal = monthlyTotal + categories[category];
    });
    categories.oneTimeTotal = oneTimeTotal;
    categories.monthlyTotal = monthlyTotal;

    // Fix decimal values to two decimal places (keep whole numbers without decimals).
    Object.keys(categories).forEach(key => {
      categories[key] =
        categories[key] % 1 !== 0
          ? categories[key].toFixed(2)
          : categories[key];
    });
    // Adding one time cost and monthly cost to send in API request
    let wlsTotalOneTimeCost = categories.oneTimeTotal;
    let wlsTotalMonthlyCost = categories.monthlyTotal;

    if (typeof wlsTotalOneTimeCost !== 'string') {
      wlsTotalOneTimeCost = wlsTotalOneTimeCost.toFixed(2);
    }
    if (typeof wlsTotalMonthlyCost !== 'string') {
      wlsTotalMonthlyCost = wlsTotalMonthlyCost.toFixed(2);
    }
    localStorage.setItem('wlsTotalOneTimeCost', wlsTotalOneTimeCost);
    localStorage.setItem('wlsTotalMonthlyCost', wlsTotalMonthlyCost);
    // Adding additional content to values
    categories.oneTimeTotal = categories.oneTimeTotal + ' (Approx.)';
    categories.monthlyTotal =
      categories.monthlyTotal + ' Plus applicable taxes';

    const isAccessoriesOnly =
      orderData.orderNotEligibleforMssReason &&
      (orderData.orderNotEligibleforMssReason.includes(
        AccessoriesOnlyEnglish
      ) ||
        orderData.orderNotEligibleforMssReason.includes(AccessoriesOnlyFrench));

    return (
      <>
        {!isAccessoriesOnly && (
          <>
            <Heading level="h3">{TotalContractValue}</Heading>
            <br />
            <Heading level="h4">One-time costs</Heading>
            <br />
            <table>
              <thead>
                <tr>
                  <th>
                    <Heading level="h4">
                      {CATEGORIES.HEADERS.CATEGORIES}
                    </Heading>
                  </th>
                  <th>
                    <Heading level="h4">{CATEGORIES.HEADERS.AMOUNT}</Heading>
                  </th>
                </tr>
              </thead>
              <tbody>
                {wlsOneTimeCategories
                  .filter(cat =>
                    cat === 'accessoriesTotal' && isChannelSevenX ? false : true
                  )
                  .map(cat => (
                    <tr>
                      <td>
                        {wirelessOrderDetailsSummaryOneTimeCategories[cat]}
                      </td>
                      <td style={{ width: '40%' }}>{categories[cat]}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <br />
            <br />
            <Heading level="h4">Monthly costs</Heading>
            <br />
            <table>
              <thead>
                <tr>
                  <th>
                    <Heading level="h4">
                      {CATEGORIES.HEADERS.CATEGORIES}
                    </Heading>
                  </th>
                  <th>
                    <Heading level="h4">{CATEGORIES.HEADERS.AMOUNT}</Heading>
                  </th>
                </tr>
              </thead>
              <tbody>
                {wlsRecurringCategories.map(cat => (
                  <tr>
                    <td>{wirelessOrderDetailsSummaryMonthlyCategories[cat]}</td>
                    <td style={{ width: '40%' }}>{categories[cat]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <br />
          </>
        )}
        {isChannelSevenX && (
          <Text bold={true} size={'small'}>
            Note: All promotions are subject to eligibility and as such are not
            calculated in cost estimates.
          </Text>
        )}
        {devices && devices.length > 1 && !isAccessoriesOnly && (
          <>
            <Heading level="h3">{HardwareSummary}</Heading>
            <br />
          </>
        )}
        <table>
          {devices && devices.length > 0 && !isAccessoriesOnly && (
            <>
              <thead>
                <tr>
                  {Object.keys(HARDWARE.HEADERS).map(h => (
                    <th>
                      <Heading level="h4">{HARDWARE.HEADERS[h]}</Heading>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {devices.map(item => {
                  const subscriberDetailsDevices =
                    item.subscriberDetailsDevices || {};
                  if (!isEmpty(subscriberDetailsDevices)) {
                    const {
                      selectedsku,
                      device_name: deviceName,
                      selectedColor,
                      mtmprice
                    } = subscriberDetailsDevices;
                    let valueSKU = '';
                    if (!isEmpty(selectedsku)) {
                      valueSKU = isArray(selectedsku)
                        ? selectedsku[0].trim().split(' ')[0]
                        : selectedsku.trim().split(' ')[0];
                    }
                    return (
                      <tr>
                        <td>{valueSKU || ``}</td>
                        <td>{deviceName || ``}</td>
                        <td>{selectedColor || ``}</td>
                        <td>{mtmprice || ``}</td>
                        <td>{1}</td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </>
          )}
        </table>
        {subscriberDetails &&
          subscriberDetails.length &&
          subscriberDetails.map((sd, idx) => (
            <>
              <br />
              <Heading level="h3">
                {SUBSCRIBER} # {idx + 1}
              </Heading>
              <br />
              {rowCb(formStepFields, sd)}
            </>
          ))}
      </>
    );
  };

  const isAccessoriesOnly =
    orderData.orderNotEligibleforMssReason &&
    (orderData.orderNotEligibleforMssReason.includes(AccessoriesOnlyEnglish) ||
      orderData.orderNotEligibleforMssReason.includes(AccessoriesOnlyFrench));

  return (
    <>
      <ExpandCollapse tag="h2">
        {summaryStepsData &&
          summaryStepsData.map(
            ({
              fields: {
                name: stepName,
                backendKey: stepBackendKey,
                formStepFields
              }
            }) => (
              <ExpandCollapse.Panel
                id={stepBackendKey}
                header={stepName}
                key={stepBackendKey}
              >
                <>
                  {stepBackendKey === BACKEND_KEYS.officePhone &&
                    handleOfficePhone(stepName, formStepFields)}
                  {stepBackendKey === BACKEND_KEYS.wirelessOrderDetails &&
                    handleWirelessSummary(stepName, formStepFields)}
                  {![
                    BACKEND_KEYS.officePhone,
                    BACKEND_KEYS.wirelessOrderDetails
                  ].includes(stepBackendKey) &&
                    formStepFields &&
                    rowCb(formStepFields)}
                </>
              </ExpandCollapse.Panel>
            )
          )}
        {!isAccessoriesOnly ? (
          <ExpandCollapse.Panel id={Features} header={Features}>
            <table>
              <thead>
                <tr>
                  {summaryFeatures.length > 0 &&
                    [Name, Price].map(item => <th>{item}</th>)}
                </tr>
              </thead>
              <tbody>
                {summaryFeatures.map((d, index) => {
                  if (!isEmpty(d)) {
                    return (
                      <tr key={index}>
                        <td>{d.name}</td>
                        <td>{d.price}</td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </ExpandCollapse.Panel>
        ) : null}
        <ExpandCollapse.Panel id={Accessories} header={Accessories}>
          <table>
            <thead>
              <tr>
                {summaryAccessories.length > 0 &&
                  [
                    accessoryValues.Category,
                    accessoryValues.Product,
                    accessoryValues.SKU,
                    accessoryValues.Price
                    // accessoryValues.Tax
                  ].map(item => <th>{item}</th>)}
              </tr>
            </thead>
            <tbody>
              {summaryAccessories.map((d, index) => {
                if (!isEmpty(d)) {
                  return (
                    <tr key={index}>
                      <td>{d.category}</td>
                      <td>{d.product}</td>
                      <td>{d.sku}</td>
                      <td>{d.price}</td>
                      {/* <td>{d.tax}</td> */}
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </ExpandCollapse.Panel>
      </ExpandCollapse>
    </>
  );
};

OrderSummary.propTypes = {
  stepData: PropTypes.objectOf(PropTypes.any).isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderSummary;
